export const jobStatusEnum = {
  active: 'active',
  disabled: 'disabled',
} as const

export type JobStatusEnum = (typeof jobStatusEnum)[keyof typeof jobStatusEnum]

export type JobStatus = JobStatusEnum